import StocksGestionRapportActiviteController from './stocks.gestion.rapport.activite.controller';
import Template from './stocks.gestion.rapport.activite.html';

export default {
	controller: StocksGestionRapportActiviteController,
	template: Template
};
